<form class="k-form k-form-md">
    <div id="optionalParameters">
        <h1>Opperating Parameters</h1>
        <hr style="margin-top: 0px !important;">
        <div class="row">
            <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                            ROP <label *ngIf="SecondaryMeasurementUnits$"> {{SecondaryMeasurementUnits$.Rop}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="RopLower" text="Lower"></kendo-label>
                            <kendo-numerictextbox #RopLower formControlName="RopLower" (valueChange)="changeIndividualTick('Rop')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="RopUpper" text="Upper"></kendo-label>
                            <kendo-numerictextbox #RopUpper formControlName="RopUpper" (valueChange)="changeIndividualTick('Rop')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-12">
                            <kendo-rangeslider  formControlName="RopLimit" [min]="0" [max]="100" style="width: 100% !important;" tickPlacement="none" (valueChange)="onValueChangeSlider($event, 'Rop')"></kendo-rangeslider>
                        </kendo-formfield>
                    </div>
            </div>
            <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                            WOB <span *ngIf="SecondaryMeasurementUnits$"> {{SecondaryMeasurementUnits$.Wob}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="WobLower" text="Lower"></kendo-label>
                            <kendo-numerictextbox #WobLower formControlName="WobLower" (change)="changeIndividualTick('Wob')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="WobUpper" text="Upper"></kendo-label>
                            <kendo-numerictextbox #WobUpper formControlName="WobUpper" (change)="changeIndividualTick('Wob')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-12">
                            <kendo-rangeslider  formControlName="WobLimit" [min]="0" [max]="100" style="width: 100% !important;" tickPlacement="none" (valueChange)="onValueChangeSlider($event, 'Wob')"></kendo-rangeslider>
                        </kendo-formfield>
                    </div>
            </div>
            <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                            TOB <span *ngIf="SecondaryMeasurementUnits$"> {{SecondaryMeasurementUnits$.Tob}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="TobLower" text="Lower"></kendo-label>
                            <kendo-numerictextbox #TobLower formControlName="TobLower" (change)="changeIndividualTick('Tob')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="TobUpper" text="Upper"></kendo-label>
                            <kendo-numerictextbox #TobUpper formControlName="TobUpper" (change)="changeIndividualTick('Tob')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-12">
                            <kendo-rangeslider  formControlName="TobLimit" [min]="0" [max]="100" style="width: 100% !important;" tickPlacement="none" (valueChange)="onValueChangeSlider($event, 'Tob')"></kendo-rangeslider>
                        </kendo-formfield>
                    </div>
            </div>
        </div>
    
        <div class="row">
            <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                           <span *ngIf="SecondaryMeasurementUnits$"> {{SecondaryMeasurementUnits$.Rpm.toUpperCase()}}</span><span *ngIf="!SecondaryMeasurementUnits$">RPM</span>
                        </div>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="RpmLower" text="Lower"></kendo-label>
                            <kendo-numerictextbox #RpmLower formControlName="RpmLower" (change)="changeIndividualTick('Rpm')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="RpmUpper" text="Upper"></kendo-label>
                            <kendo-numerictextbox #RpmUpper formControlName="RpmUpper" (change)="changeIndividualTick('Rpm')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-12">
                            <kendo-rangeslider  formControlName="RpmLimit" [min]="0" [max]="100" style="width: 100% !important;" tickPlacement="none" (valueChange)="onValueChangeSlider($event, 'Rpm')"></kendo-rangeslider>
                        </kendo-formfield>
                    </div>
            </div>
            <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                            Flow Rate  <span *ngIf="SecondaryMeasurementUnits$"> {{SecondaryMeasurementUnits$.FlowRate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="FlowRateLower" text="Lower"></kendo-label>
                            <kendo-numerictextbox #FlowRateLower formControlName="FlowRateLower" (change)="changeIndividualTick('FlowRate')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                        <kendo-formfield class="col-md-6">
                            <kendo-label [for]="FlowRateUpper" text="Upper"></kendo-label>
                            <kendo-numerictextbox #FlowRateUpper formControlName="FlowRateUpper" (change)="changeIndividualTick('FlowRate')" [min]="0" [max]="100"></kendo-numerictextbox>
                        </kendo-formfield>
                    </div>
                    <div class="row">
                        <kendo-formfield class="col-md-12">
                            <kendo-rangeslider  formControlName="FlowRateLimit" [min]="0" [max]="100" style="width: 100% !important;" tickPlacement="none" (valueChange)="onValueChangeSlider($event, 'FlowRate')"></kendo-rangeslider>
                        </kendo-formfield>
                    </div>
            </div>
            <div class="col-md-4">
                <kendo-formfield>
                    <kendo-label [for]="mudTypes" text="Mud Types"></kendo-label>
                    <kendo-multiselect formControlName="mudTypes" #mudTypes valueField="ID" textField="Name"></kendo-multiselect>
                </kendo-formfield>
            </div>
        </div>
    </div>
</form>